import {createActions, using} from 'redux-box'

export default createActions({
    requestLevels: using(),
})